<template>
    <div class="row vertical-align" id="containerBeforeSearch">
      <div class="jumbotron">
        <div class="container">
          <div class="row">
            <h2>CrossAsia "Guided" Fulltext Search (Beta version, type A)</h2>
          </div>
          <br/>
          <div class="row">
            <form class="form-inline" v-on:submit.prevent>
              <div class="form-group" style="width:100%;text-align: center;">
                <input v-on:keyup.enter="search2" class="form-control input-lg" v-model.trim="keyword" placeholder="Search in full text" style="width:50%" /><button type="button" class="btn btn-lg"v-on:click='search2' id='searchBtn2' :disabled='keyword.length == 0' ><icon name='search'></icon></button>
              </div>
            </form>
          </div>
          <br/>
          <div class="row">
            <!--<p style="font-size: 1.5em !important;">Search the fulltexts of about 120,094 titles with 13 million pages archived in the CrossAsia Integrated Textrepository (CrossAsia ITR)</p>-->
            <!--<p style="font-size: 1.5em !important;"></p>-->
            <vue-tabs active-text-color="#b41815">
            <v-tab title="Features">
              <ul>
                <ul>
                  <li style="list-style-type: none;">
                    <h4>Sorting of hits:</h4>
                    <ul>
                      <li style="fon-size: 1.3em !important;" >page hits are grouped by book titles. Use left hand column to browse through titles, select a title to show its page hits</li>
                      <li style="fon-size: 1.3em !important;" >titles are shown according to the number of pages that contain the search term(s) no matter how often; pages are shown in the sequence of the book</li>
                    </ul>
                  </li>
                  <li style="list-style-type: none;">
                    <h4>Searching:</h4>
                    <ul>
                      <li style="fon-size: 1.3em !important;" >"AB C" (using quotation marks) finds the exact string 'AB C'; A B C finds pages where A and B and C are found; fish* finds 'fishing' and 'Fishery' (there is no need to truncate Chinese characters)</li>
                      <li style="fon-size: 1.3em !important;" >search for Latin script terms is not case sensitive; search for Chinese characters can be performed in traditional and simplified form</li>
                      <li style="fon-size: 1.3em !important;" >"empty" searches are not possible</li>
                    </ul>
                  </li>
                  <li style="list-style-type: none;">
                    <h4>Filtering:</h4>
                    <ul>
                      <li style="fon-size: 1.3em !important;" >control results by selecting filter terms in the right hand column. You may also search within filter terms (type 王 in the Author filter to get a list of all names containing "王"</li>
                      <li style="fon-size: 1.3em !important;" >Select one or more filter terms from a category and click "filter" to apply; the set filter will appear at the top of the right hand column</li>
                      <li style="fon-size: 1.3em !important;" >•	Use “x” to de-select the filter; click the lock <icon name="lock" style="color:#b41815"></icon> to keep the filter for other search terms</li>
                    </ul>
                  </li>
                  <li style="list-style-type: none;">
                    <h4>Accessing:</h4>
                    <ul>
                      <li style="fon-size: 1.3em !important;" >use the icons for database <icon name="database" style="color:#b41815"></icon>, book <icon name="book" style="color:#b41815"></icon>, and page <icon name="file" style="color:#b41815"></icon> to open the object in the database. The red icons provide access for authenticated CrossAsia users; grey icons can be used if you have any other IP or login access; green icons are Open Acces; orange icons link to database object that require the set-up of an individual free account.</li>
                      <li style="fon-size: 1.3em !important;" >Note: For some items (Local Gazetteers, People's Daily) only a link to the database can be provided. Use title and page number or date and title to find the object in the database. </li>
                    </ul>
                  </li>
                  <li style="list-style-type: none;">
                    <h4>Other:</h4>
                    <ul>
                      <li style="fon-size: 1.3em !important;" >To get back to this page click the <icon name="info-circle" style="color:#b41815"></icon> next to the search slot.</li>
                      <li style="fon-size: 1.3em !important;" >The <icon name="info-circle" style="color:#b41815"></icon> next to a collection title in the right hand column informs about content and specifics of the respective resource</li>
                    </ul>
                  </li>
                </ul>
                <!--<li style="fon-size: 1.3em !important;" >clicking the search button without entering any search term will return all titles and their filter terms (no page hits will be shown, as this search only searches page/article contents). This will also give an overview of the currently included collections. For more information about each collections click the <icon name="info-circle" style="color:#b41815"></icon> next to the collection title under filters. </li>-->
                
              </ul>
            </v-tab>
            <!--<v-tab title="Resources">-->
            <!--  <ul>-->
            <!--    <template  v-for="(record,index) in sortedInfo">-->
            <!--      <li style="fon-size: 1.3em !important;" ><a target='_blank' :href='record[1].link'>{{record[1].title}}</a> <a @click="popup(record[0])"><icon name='info-circle'></icon></a></li>-->
            <!--    </template>-->
            <!--  </ul>-->
            <!--</v-tab>-->
          </vue-tabs>
            <p style="font-size: 1.5em !important;"></p>
            <p style="fon-size: 1.5em !important;">For feedback, questions etc. please contact <a href="mailto:x-asia@sbb.spk-berlin.de">x-asia@sbb.spk-berlin.de</a></p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {VueTabs, VTab} from 'vue-nav-tabs' // you can also import this in your style tag

import setting from 'crossasia-itr-fulltextsearch-setting'
const info = setting.info

export default {
  created: function () {
  },
  watch: {
    // '$route': 'fetchData'
  },
  name: 'FrontPage',
  // props: ['results'],
  components: {
    VueTabs,
    VTab
  },
  data: function () {
    return {
      keyword: '',
      info: info
    }
  },
  methods: {
    search2: function () {
      // if (this.keyword.trim().length === 0) {
      //   return
      // }
      this.$router.push({name: 'search', query: { q: this.keyword.trim() }, props: true})
      // this.start = true
      // this.search()
    }
  },
  computed: {
    sortedInfo: function () {
      return Object.entries(this.info).sort(function (entryA, entryB) {
        return entryA[1].keyForSorting.toLowerCase() > entryB[1].keyForSorting.toLowerCase() ? 1 : -1
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.vue-tabs {
  font-size: 14px;
}

/*.container ul {*/
/*  font-size: 14px !important;*/
/*}*/

/*.container .columnContent.left ul {*/
/*  font-size: 14px !important;*/
/*}*/

span.title {
  font-size: 14px !important;
}

#containerBeforeSearch {
  padding-top: 0px !important;
  margin-right: 0px !important;
}

.jumbotron {
    background-color: #fff;
}

#searchBtn2 {
    background-color: #b41815;
    border-color: #861210;
    color: #fff;
}

.fa-icon {
  width: 1em;
  height: 1em; /* or any other relative font sizes */

  /* You would have to include the following two lines to make this work in Safari */
  max-width: 100%;
  max-height: 100%;
}
a {
 color: #b41815 !important;
}
a:hover  {
  color: black;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/FrontPage.vue